import { render, staticRenderFns } from "./SpkbExchange.vue?vue&type=template&id=462381b2&"
import script from "./SpkbExchange.vue?vue&type=script&lang=js&"
export * from "./SpkbExchange.vue?vue&type=script&lang=js&"
import style0 from "./SpkbExchange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports